let storage = {
  setCookie(name,value){
      var Days = 99*365; //cookie有效期
      var exp = new Date();
      exp.setTime(exp.getTime() + Days*24*60*60*1000);
      document.cookie = name + "=" + escape (value) + ";expires=" + exp.toGMTString();
  },

  getCookie(name){    
      var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
      if(arr=document.cookie.match(reg))
          return unescape(arr[2]);
      else
          return null;
  },

  delCookie(name){
      var exp = new Date();
      exp.setTime(exp.getTime() - 1);
      var cval=getCookie(name);
      if(cval!=null)
          document.cookie= name + "="+cval+";expires="+exp.toGMTString();
  },

  clearAllCookie() {
    var date = new Date();
    date.setTime(date.getTime()-10000);
    var keys=document.cookie.match(/[^ =;]+(?==)/g);
    if (keys) {
        for (var i =  keys.length; i--;)
          document.cookie=keys[i]+"=0; expire="+date.toGMTString()+"; path=/";
    }
  },

  /**
     对本地数据进行操作的相关方法，如localStorage,sessionStorage的封装
  */
  setStorage: function (key, value, duration) {
    var data = {
      value: value,
      expiryTime: !duration || isNaN(duration) ? 0 : this.getCurrentTimeStamp() + parseInt(duration)
    }
    localStorage[key] = JSON.stringify(data)
  },
  getStorage: function (key) {
    var data = localStorage[key]
    if (!data || data === 'null') {
      return null
    }
    var now = Date.now()
    var obj
    try {
      obj = JSON.parse(data)
    } catch (e) {
      return null
    }
    if (obj.expiryTime === 0 || obj.expiryTime > now) {
      return obj.value
    }
    return null
  },

  setAuth: function(value) {
    this.setCookie("09auth", value);
  },
  getAuth: function() {
    return this.getCookie("09auth");
  },
  setOpenId: function(value) {
    this.setCookie("09openId", value);
  },
  getOpenId: function() {
    return this.getCookie("09openId");
  },
  setmKey: function(value) {
    this.setCookie("09m_key", value);
  },
  getmKey: function() {
    return this.getCookie("09m_key");
  },
  setToken: function(value) {
    this.setStorage("09Token", value);
  },
  getToken: function() {
    return this.getStorage("09Token");
  },
  setHeadId: function(value) {
    this.setStorage("09headId", value);
  },
  getHeadId: function() {
    return this.getStorage("09headId");
  },
  setUserName: function(value) {
    this.setStorage("09userName", value);
  },
  getUserName: function() {
    return this.getStorage("09userName");
  },
  setUserId: function(value) {
    this.setStorage("09userId", value);
  },
  getUserId: function() {
    return this.getStorage("09userId");
  },
  setUserLevel: function(value) {
    this.setStorage("09userLv", value);
  },
  getUserLevel: function() {
    return this.getStorage("09userLv");
  },
  setUserFlag: function(value) {
    this.setStorage("09userFlag", value);
  },
  getUserFlag: function() {
    return this.getStorage("09userFlag");
  },
  setAccountList: function(value) {
    this.setStorage("09accountList", value);
  },
  getAccountList: function() {
    return this.getStorage("09accountList");
  },

}

export default storage


// WEBPACK FOOTER //
// ./src/utils/Storage.js